import { defineMessages } from 'react-intl';

export default defineMessages({
  moreCardsHeader: {
    id: 'accountCards.cards.otherCards',
    defaultMessage: 'More cards',
    description: 'A header for the section of other cards',
  },
});
